import * as Sentry from '@sentry/nuxt'

const isProduction = process.env.VERCEL_ENV === 'production'

Sentry.init({
  dsn: useRuntimeConfig().public.sentry.dsn,

  sendDefaultPii: true,

  environment: process.env.SENTRY_ENVIRONMENT || (isProduction ? 'production' : 'staging'),

  release: process.env.VERCEL_GIT_COMMIT_SHA,

  // --- Tracing -------------------------------------------------------------
  // browserTracingIntegration is enabled by default by @sentry/nuxt.
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0.15,

  // Only attach sentry-trace / baggage headers to our own origins so we never
  // leak trace headers to third parties.
  tracePropagationTargets: [
    /^\//,
    /^https:\/\/(www\.)?johnsenpartner\.de/,
    /^https?:\/\/localhost/
  ],

  // --- Logs ----------------------------------------------------------------
  enableLogs: true,

  // --- Metrics -------------------------------------------------------------
  enableMetrics: true,

  // --- Profiling -----------------------------------------------------------
  // Requires the `Document-Policy: js-profiling` response header (set in
  // nuxt.config.ts routeRules) and only collects data in Chromium browsers.
  // Evaluated once per page load: a session either profiles all its sampled
  // traces or none of them.
  profileSessionSampleRate: isProduction ? 0.2 : 1,
  profileLifecycle: 'trace',

  integrations: [
    Sentry.browserProfilingIntegration(),
    // `vite-plugin-remove-console` strips console.log from production builds,
    // so only warn/error would ever reach Sentry anyway.
    Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] })
  ],

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false
})
